import flatpickr from 'flatpickr';
import German from 'flatpickr/dist/l10n/de.js';

function initFlatPickr() {
    const dateInput = document.querySelector('#daySpaForm-date');

    const arrivalInput = document.querySelector('#inquiryFormHotel-arrivalDate');
    const alternativeArrivalInput = document.querySelector('#inquiryFormHotel-alternativeArrivalDate');
    const departureInput = document.querySelector('#inquiryFormHotel-departureDate');
    const alternativeDepartureInput = document.querySelector('#inquiryFormHotel-alternativeDepartureDate');

    const commonOptions = {
        // today + 1 day
        minDate: new Date().fp_incr(1),
        altFormat: 'd. m. Y',
        altInput: true,
        locale: document.documentElement.lang || 'en',
        // we need this for HTML 5 validation
        // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
        allowInput: true,
    };

    if (!dateInput && (!arrivalInput || !departureInput || !alternativeArrivalInput || !alternativeDepartureInput)) {
        return;
    } else if (dateInput) {
        dateInput.nextElementSibling.onkeypress = () => false;
        return;
    }

    let minDepartureDate = arrivalInput.value ? new Date(arrivalInput.value) : null;

    const arrivalFlatPickr = flatpickr(arrivalInput, commonOptions);
    const alternativeArrivalFlatPickr = flatpickr(alternativeArrivalInput, commonOptions);
    const departureFlatPickr = flatpickr(departureInput, commonOptions);
    const alternativeDepartureFlatPickr = flatpickr(alternativeDepartureInput, commonOptions);

    if (minDepartureDate instanceof Date) {
        departureFlatPickr.config.minDate = minDepartureDate;
        alternativeDepartureFlatPickr.config.minDate = minDepartureDate;
    }

    arrivalFlatPickr.config.onChange.push((selectedDates) => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
            handleAlternativeDatesButtonVisibility(document.querySelector('.js-alternative-dates-button'));
        }

        if (minDepartureDate instanceof Date) {
            departureFlatPickr.config.minDate = minDepartureDate;
        }
    });

    alternativeArrivalFlatPickr.config.onChange.push((selectedDates) => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
        }

        if (minDepartureDate instanceof Date) {
            alternativeDepartureFlatPickr.config.minDate = minDepartureDate;
        }
    });

    departureFlatPickr.config.onChange.push(() => {
        handleAlternativeDatesButtonVisibility(document.querySelector('.js-alternative-dates-button'));
    });

    departureFlatPickr.config.onOpen.push(() => {
        if (departureFlatPickr.config.minDate instanceof Date) {
            let openDate = departureInput.value ? new Date(departureInput.value) : departureFlatPickr.config.minDate;
            departureFlatPickr.changeYear(openDate.getFullYear(), false);
            departureFlatPickr.changeMonth(openDate.getMonth(), false);
        }
    });

    alternativeDepartureFlatPickr.config.onOpen.push(() => {
        if (alternativeDepartureFlatPickr.config.minDate instanceof Date) {
            let openDate = alternativeDepartureInput.value
                ? new Date(alternativeDepartureInput.value)
                : alternativeDepartureFlatPickr.config.minDate;
            alternativeDepartureFlatPickr.changeYear(openDate.getFullYear(), false);
            alternativeDepartureFlatPickr.changeMonth(openDate.getMonth(), false);
        }
    });

    // we need this for HTML 5 validation
    // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
    arrivalInput.nextElementSibling.onkeypress = () => false;
    alternativeArrivalInput.nextElementSibling.onkeypress = () => false;
    departureInput.nextElementSibling.onkeypress = () => false;
    alternativeDepartureInput.nextElementSibling.onkeypress = () => false;
}

initFlatPickr();

function showChildAgeFields() {
    const childrenFields = document.querySelectorAll('.js-children');

    childrenFields.forEach((childField) => {
        const childAgeFields = childField.parentElement.parentElement.querySelectorAll('.js-child-age');

        if (!childAgeFields || !childField) {
            return;
        }
        function removeFields() {
            const childFieldValue = parseInt(childField.value);
            const headline = childField.parentElement.nextElementSibling?.querySelector('.form-heading--ages');
            if (childFieldValue && childFieldValue > 0) {
                if (headline) {
                    headline.style.display = 'block';
                }
            } else {
                if (headline) {
                    headline.style.display = 'none';
                }
            }

            [...childAgeFields].forEach((childAgeField, index) => {
                if (index > childFieldValue - 1 || !childFieldValue) {
                    childAgeField.classList.add('input--hidden');
                    childAgeField.querySelector('input').required = false;
                    childAgeField.querySelector('input').value = '';
                } else {
                    childAgeField.classList.remove('input--hidden');
                    childAgeField.querySelector('input').required = true;
                }
            });
        }

        removeFields();

        childField.addEventListener('input', removeFields);
    });
}

showChildAgeFields();

function insertRoomImagesToCheckboxes() {
    const roomImages = [];

    // collect images in array and use id as key
    const template = document.querySelector('#room-images');
    const container = document.createElement('div');
    container.appendChild(template.content.cloneNode(true));

    if (container) {
        const images = container.querySelectorAll('img');
        [...images].forEach((img) => {
            roomImages[img.getAttribute('data-re-guest-id')] = img;
        });
    }

    //insert images
    const inputs = document.querySelectorAll(
        'input[name="--inquiryFormHotel[room]"], input[name="--inquiryFormHotel[additionalRoom]"]'
    );
    [...inputs].forEach((input) => {
        const imgEl = roomImages[input.getAttribute('value')];
        input.parentNode.insertBefore(imgEl.cloneNode(), input.nextSibling);
    });
}

insertRoomImagesToCheckboxes();

function initFlatPickrForAvailableFrom() {
    const availableFromInput = document.querySelector('#jobApplicationForm-availableFrom');

    if (!availableFromInput) {
        return;
    }

    const commonOptions = {
        // today + 1 day
        minDate: new Date().fp_incr(1),
        altFormat: 'd. m. Y',
        altInput: true,
        locale: document.documentElement.lang || 'en',
        // we need this for HTML 5 validation
        // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
        allowInput: true,
    };

    if (
        !availableFromInput &&
        (!dateInput || !arrivalInput || !departureInput || !alternativeArrivalInput || !alternativeDepartureInput)
    ) {
        return;
    } else if (availableFromInput) {
        const dateFlatPickr = flatpickr(availableFromInput, commonOptions);
        availableFromInput.nextElementSibling.onkeypress = () => false;
        return;
    }
}
initFlatPickrForAvailableFrom();

// Sort Countries alphabetically
const selectCountry = document.querySelector('#inquiryFormHotel-country');

if (selectCountry) {
    sortCountries(selectCountry.getElementsByTagName('option'));
}

function sortCountries(optionFields) {
    var countryOptionArrayTop = [];
    var countryOptionArray = [];

    [...optionFields].forEach((countryOption) => {
        if (countryOption.value != 'de' && countryOption.value != 'at' && countryOption.value != 'ch') {
            countryOptionArray.push([countryOption.text, countryOption.value]);
        } else {
            countryOptionArrayTop.push([countryOption.text, countryOption.value]);
        }
        countryOption.remove();
    });
    countryOptionArray = countryOptionArrayTop.concat(countryOptionArray.sort(new Intl.Collator('de').compare));

    const selectBox = document.getElementById('inquiryFormHotel-country');
    for (var i = 0; countryOptionArray.length > i; i++) {
        selectBox.add(
            new Option(countryOptionArray[i][0], countryOptionArray[i][1] + ' - ' + countryOptionArray[i][0])
        );

        if (i === 2) {
            var disabledOption = new Option('-------------', '');
            disabledOption.disabled = true;
            selectBox.add(disabledOption);
        }
    }
}

// Prevent negative numbers
function preventNegativeNumbers() {
    const numberInput = document.querySelectorAll('input[type="number"]');

    [...numberInput].forEach((input) => {
        if (input.id == 'inquiryFormHotel-adults') {
            input.setAttribute('min', 1);
        } else {
            input.setAttribute('min', 0);
        }
    });
}
preventNegativeNumbers();

function filterRoomsByAdultsAndChildrenFields(adultField, childrenField, roomsContainer) {
    if (!adultField || !childrenField || !roomsContainer) {
        return;
    }

    const roomImages = roomsContainer.querySelectorAll('.room-image');

    function filterRooms() {
        const totalNumberOfGuests =
            (Number.isNaN(parseInt(adultField.value)) ? 0 : parseInt(adultField.value)) +
            (Number.isNaN(parseInt(childrenField.value)) ? 0 : parseInt(childrenField.value));

        if (totalNumberOfGuests > 0) {
            [...roomImages].forEach((roomImage) => {
                const maxOccupancy = parseInt(roomImage.getAttribute('data-max-occupancy'));

                // if the max occupancy is not set for a room, we won't filter it
                // since it's safer to always show it
                if (Number.isNaN(maxOccupancy)) {
                    return;
                }

                if (totalNumberOfGuests > maxOccupancy) {
                    roomImage.parentNode.querySelector('input').checked = false;
                    roomImage.parentNode.classList.add('room--disabled');
                    roomImage.parentNode.classList.remove('room--selected');
                } else {
                    roomImage.parentNode.classList.remove('room--disabled');
                }
            });
        }
    }
    filterRooms();

    adultField.addEventListener('input', filterRooms);
    childrenField.addEventListener('input', filterRooms);
}

filterRoomsByAdultsAndChildrenFields(
    document.querySelector('#inquiryFormHotel-adults'),
    document.querySelector('#inquiryFormHotel-children'),
    document.querySelector('.js-main-room-selection')
);

filterRoomsByAdultsAndChildrenFields(
    document.querySelector('#inquiryFormHotel-additionalAdults'),
    document.querySelector('#inquiryFormHotel-additionalChildren'),
    document.querySelector('.js-additional-room-selection')
);

function onRoomSelect(selectedValue, allRoomInputsFromGroup) {
    [...allRoomInputsFromGroup].forEach((roomInput) => {
        if (roomInput.value === selectedValue) {
            roomInput.parentNode.classList.add('room--selected');
        } else {
            roomInput.parentNode.classList.remove('room--selected');
            roomInput.checked = false;
            roomInput.removeAttribute('checked');
        }
    });
}

[...document.querySelectorAll('input[name="--inquiryFormHotel[room]"]')].forEach(
    (input, index, allRoomInputsFromGroup) => {
        input.addEventListener('change', () => {
            onRoomSelect(input.value, allRoomInputsFromGroup);
        });
    }
);
[...document.querySelectorAll('input[name="--inquiryFormHotel[additionalRoom]"]')].forEach(
    (input, index, allRoomInputsFromGroup) => {
        input.addEventListener('change', () => {
            onRoomSelect(input.value, allRoomInputsFromGroup);
        });
    }
);

function markPresSelectedRoom(roomInputs) {
    if (!roomInputs) {
        return;
    }

    [...roomInputs].forEach((roomInput) => {
        if (roomInput.checked) {
            roomInput.parentNode.classList.add('room--selected');
        }
    });
}

markPresSelectedRoom(document.querySelectorAll('input[name="--inquiryFormHotel[room]"]'));

function enableRoomSelection(roomSelectionEnablerInput) {
    if (!roomSelectionEnablerInput) {
        return;
    }

    const roomSelection = roomSelectionEnablerInput.closest('.form__section').querySelector('.room-selector');

    if (!roomSelection) {
        return;
    }

    const showRoomSelection = roomSelectionEnablerInput.checked && roomSelectionEnablerInput.value === '1';

    if (showRoomSelection) {
        roomSelection.style.display = 'block';
    } else {
        roomSelection.style.display = 'none';
        if (roomSelection.querySelector('input:checked')) {
            roomSelection.querySelector('input:checked').checked = false;
            roomSelection.querySelector('input:checked').removeAttribute('checked');
        }
        if (roomSelection.querySelector('.room--selected')) {
            roomSelection.querySelector('.room--selected').classList.remove('room--selected');
        }
    }
}

[...document.querySelectorAll('.js-room-selection-enabler')].forEach((roomSelectionEnablerInput) => {
    roomSelectionEnablerInput.addEventListener('change', () => {
        enableRoomSelection(roomSelectionEnablerInput);
    });
});

function showRoomSelectionIfRoomParameterIsSet() {
    const roomSelection = document.querySelector('.js-main-room-selection');
    if (!roomSelection) {
        return;
    }

    const roomParameter = new URLSearchParams(window.location.search).get('room');
    if (roomParameter) {
        roomSelection.style.display = 'block';
    }

    const roomEnablerRadioButtons = roomSelection
        .closest('.form__section')
        .querySelectorAll('.js-room-selection-enabler');

    if (roomEnablerRadioButtons && roomParameter) {
        [...roomEnablerRadioButtons].forEach((roomEnablerRadioButton) => {
            roomEnablerRadioButton.checked = roomEnablerRadioButton.value === '1';
        });
    }
}

showRoomSelectionIfRoomParameterIsSet();

function handleAlternativeDatesButtonVisibility(alternativeDatesButton) {
    if (!alternativeDatesButton) {
        return;
    }

    const arrivalDateValue = document.querySelector('#inquiryFormHotel-arrivalDate')?.value;
    const departureDateValue = document.querySelector('#inquiryFormHotel-departureDate')?.value;

    // when no from or until date is set, hide button
    if (!arrivalDateValue || !departureDateValue) {
        alternativeDatesButton.style.display = 'none';
    } else {
        alternativeDatesButton.style.display = '';
    }
}

function handleAlternativeDatesVisibility(alternativeDatesButton, alternativeArrivalDateSelectorContainer) {
    if (!alternativeDatesButton || !alternativeArrivalDateSelectorContainer) {
        return;
    }

    const alternativeArrivalDateValue = document.querySelector('#inquiryFormHotel-alternativeArrivalDate')?.value;
    const alternativeDepartureDateValue = document.querySelector('#inquiryFormHotel-alternativeDepartureDate')?.value;

    if (!alternativeArrivalDateValue && !alternativeDepartureDateValue) {
        alternativeArrivalDateSelectorContainer.style.display = 'none';
    } else {
        alternativeArrivalDateSelectorContainer.style.display = '';
    }

    alternativeDatesButton.addEventListener('click', () => {
        alternativeArrivalDateSelectorContainer.style.display = '';
    });
}

function setAlternativeDatesRequired() {

    const alternativeArrivalInput = document.querySelector('#inquiryFormHotel-alternativeArrivalDate');
    const alternativeDepartureInput =  document.querySelector('#inquiryFormHotel-alternativeDepartureDate');

    if(alternativeArrivalInput.value !== '') {
        alternativeDepartureInput.nextSibling.required = true;
    }

    if(alternativeDepartureInput.value !== '') {
        alternativeArrivalInput.nextSibling.required = true;
    }

    if(alternativeArrivalInput.value == '' && alternativeDepartureInput.value == '') {
        alternativeArrivalInput.nextSibling.required = false;
        alternativeDepartureInput.nextSibling.required = false;
    }
}

if(document.querySelector('.js-alternative-dates')) {
    const alternativeArrivalInput = document.querySelector('#inquiryFormHotel-alternativeArrivalDate');
    const alternativeDepartureInput =  document.querySelector('#inquiryFormHotel-alternativeDepartureDate');

    [ alternativeArrivalInput, alternativeDepartureInput ].forEach((alternativeDates) => {
        alternativeDates.addEventListener("input", () => {
            setAlternativeDatesRequired();
        });
    });
}

handleAlternativeDatesVisibility(
    document.querySelector('.js-alternative-dates-button'),
    document.querySelector('.js-alternative-dates')
);

function handleAdditionalRoomSelectionVisibility(
    addAdditionalRoomButton,
    removeAdditionalRoomButton,
    additionalRoomsContainer
) {
    if (!additionalRoomsContainer || !addAdditionalRoomButton || !removeAdditionalRoomButton) {
        return;
    }

    const additionalAdultsField = document.querySelector('#inquiryFormHotel-additionalAdults');
    const additionalChildrenField = document.querySelector('#inquiryFormHotel-additionalChildren');

    if (additionalChildrenField.value > 0 || additionalAdultsField.value > 0) {
        additionalRoomsContainer.style.display = 'block';
    }

    addAdditionalRoomButton.addEventListener('click', () => {
        additionalRoomsContainer.style.display = 'block';
        addAdditionalRoomButton.style.display = 'none';
        removeAdditionalRoomButton.style.display = '';
    });

    removeAdditionalRoomButton.addEventListener('click', () => {
        additionalRoomsContainer.style.display = 'none';
        addAdditionalRoomButton.style.display = '';
        removeAdditionalRoomButton.style.display = 'none';

        additionalAdultsField.value = '';
        additionalChildrenField.value = '';

        [...additionalRoomsContainer.querySelectorAll('input[name="js-additional-room-selection-enabler"]')].forEach(
            (input) => {
                if (input.value === '0') {
                    input.checked = true;
                } else {
                    input.checked = false;
                    input.removeAttribute('checked');
                }

                enableRoomSelection(input);
            }
        );

        showChildAgeFields();
    });
}

handleAdditionalRoomSelectionVisibility(
    document.querySelector('.js-add-additional-room-button'),
    document.querySelector('.js-remove-additional-room-button'),
    document.querySelector('.js-additional-room-container')
);

function showPackageMetaData(packageField) {
    if (!packageField) {
        return;
    }

    const packageFieldValue = packageField.value;

    if (!packageFieldValue) {
        return;
    }

    // load package images from template
    const template = document.querySelector('#packages-images');
    if (!template) {
        return;
    }
    const container = document.createElement('div');
    container.appendChild(template.content.cloneNode(true));

    const packageImages = container.querySelectorAll('img');

    if (!packageImages) {
        return;
    }

    const matchingImage = [...packageImages].find(
        (image) => image.getAttribute('data-re-guest-id') === packageField.value
    );

    const packageImageContainer = document.querySelector('.js-package-image-container');
    const packageLabel = document.querySelector('.js-package-label');

    if (packageImageContainer) {
        packageImageContainer.appendChild(matchingImage);
    }

    if (packageLabel) {
        const span = document.createElement('span');
        span.innerHTML = matchingImage.getAttribute('data-package-label');
        packageLabel.appendChild(span);
    }

    // show packages container (section)

    const packageContainer = document.querySelector('.js-package-container');

    if (packageContainer && matchingImage && packageLabel) {
        packageContainer.style.display = '';
    }
}

showPackageMetaData(document.querySelector('#inquiryFormHotel-package'));
